export const environment = {
  production: false,
  apiUrl: "https://app-save-api-stage.azurewebsites.net/api",
  autoLogoutMinutes: 20,
  RAFunctionUrl: "https://func-save-stage.azurewebsites.net/api/RA?code=QFY-G9RmKdvnic2fn7k8uiMV7mPUsuc9a7ISpYg5wC7vAzFueKvA-A==",
  DefineRiscoFunctionURL: "https://func-save-hom.azurewebsites.net/api/BoaVistaDefineRisco?code=DHpS8M5xreJTaHkW6IJlvfxXwEIzoB025d-NkNRym5_vAzFuxgIb6g==",
  ConsultaEssencialFunctionURL: "https://func-save-hom.azurewebsites.net/api/BoaVistaConsultaEssencial?code=9df2027bLjHMnpg4vocJfC5w3WJZvBnD7GKTKWGyXTWhAzFuEg0hPA=="
};
